import axios from 'axios'
// URL de la API
const baseURL = process.env.VUE_APP_BASE_URL_API

// Objeto axios de la api de tipo
const apiEntidad = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  //timeout: 10000, // 10 segundos de espera
})

export default {
  /**
   * @name getEntidad
   * @description Obtienen una lista de Entidades
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  getEntidad(jwt, params) {
    apiEntidad.defaults.headers.common['Authorization'] = 'Bearer ' + jwt

    if (params != null) {
      return apiEntidad.get('entidad/' + params)
    }
    return apiEntidad.get('entidad/')
  },

  /**
   * @name postEntidad
   * @description Se crea la Entidad
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  postEntidad(jwt, body) {
    apiEntidad.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiEntidad.post('entidad', body)
  },

  /**
   * @name putEntidad
   * @description Se actualiza la Entidad
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putEntidad(jwt, body, id) {
    apiEntidad.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiEntidad.put('entidad/' + id, body)
  },
  /**
   * @name deleteEntidad
   * @description Se actualiza la Entidad
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  deleteEntidad(jwt, body, id) {
    apiEntidad.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiEntidad.delete('entidad/' + id, body)
  },
}
